import { type Issue, type IssueType } from "@overmap-ai/common"
import { IssueService as OvermapIssueService } from "@overmap-ai/core"
import { saveAs } from "file-saver"
import superagent from "superagent"

import type { RootState } from "../../store"
import type { IssuePdfExportOptions } from "../../typings/reports"
import type { AppSDK } from "../sdk"
import { getFilenameFromResponse, sendAuthenticated } from "../utils"

export class IssueService extends OvermapIssueService<RootState, AppSDK> {
	host = import.meta.env.REACT_APP_API_URL

	async getIssuePdf(issueId: Issue["uuid"], options?: IssuePdfExportOptions) {
		const response = await sendAuthenticated(this.auth, () =>
			superagent
				.get(this.host + `/issue-export/pdf/${issueId}/`)
				.query(options ?? {})
				.responseType("blob"),
		)

		const filename = getFilenameFromResponse(response, "Issue.pdf")

		saveAs(response.body, filename)
	}

	async getIssuesPdf(issueTypeId: IssueType["uuid"], issueIds: Issue["uuid"][], options?: IssuePdfExportOptions) {
		const response = await sendAuthenticated(this.auth, () =>
			superagent
				.post(this.host + `/issue-export/pdf/bulk/${issueTypeId}/`)
				.send({ uuids: issueIds, options: options })
				.responseType("blob"),
		)

		const filename = getFilenameFromResponse(response, "Issues.pdf")

		saveAs(response.body, filename)
	}

	async getIssuesPdfReport(
		issueTypeId: IssueType["uuid"],
		issueIds: Issue["uuid"][],
		options?: IssuePdfExportOptions,
	) {
		await sendAuthenticated(this.auth, () =>
			superagent
				.post(this.host + `/issue-export/pdf/bulk/${issueTypeId}/`)
				.query({ report: true })
				.send({ uuids: issueIds, options: options }),
		)
	}
}
